import { convertIntoDashUSFormat } from "../../../../utilities/dateUtility";
import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";
import { EditGoalsButton } from "./editGoalsButton/editGoalsButton";
import { DeleteGoalsButton } from "./deleteGoalsButton/deleteGoalsButton";
import { isPermissionPresent } from "../../../../utilities/generalUtility";
import K from "../../../../utilities/constants";
import { Space } from "antd";

const updatedByRender = (params) => {
  return params.data.updatedBy ? params.data.updatedBy : "N/A";
};

const updatedAtRender = (params) => {
  return convertIntoDashUSFormat(params.data.updatedAt, true);
};

const actionColumnRenderer =
  (roles, onGoalsUpdated, onGoalsDeleted) => (params) => (
    <Space>
      {isPermissionPresent(K.Permissions.SuperAdmin, roles) && (
        <>
          <EditGoalsButton goal={params.data} onSuccess={onGoalsUpdated} />
          <DeleteGoalsButton goal={params.data} onSuccess={onGoalsDeleted} />
        </>
      )}
    </Space>
  );

export const getColumns = (roles, onGoalsUpdated, onGoalsDeleted) => [
  DefaultColumnOptions.Id,
  {
    field: "clientName",
    headerName: "Client",
    sortable: true,
    tooltipField: "clientName",
    sort: "asc",
  },
  {
    field: "prospect",
    headerName: "Prospects",
    sortable: true,
    tooltipField: "prospect",
  },
  {
    field: "applied",
    headerName: "Applicants",
    sortable: true,
    tooltipField: "applied",
  },
  {
    field: "phoneScreens",
    headerName: "Phone Screens",
    sortable: true,
    tooltipField: "phoneScreens",
  },
  {
    field: "submittals",
    headerName: "Submittals",
    sortable: true,
    tooltipField: "submittals",
  },
  {
    field: "interviews",
    headerName: "Interviews",
    sortable: true,
    tooltipField: "interviews",
  },
  {
    field: "offers",
    headerName: "Offers",
    sortable: true,
    tooltipField: "offers",
  },
  {
    field: "hires",
    headerName: "Hires",
    sortable: true,
    tooltipField: "hires",
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    sortable: true,
    cellRenderer: updatedByRender,
    tooltipValueGetter: (params) =>
      params.data.updatedBy ? params.data.updatedBy : "N/A",
  },
  {
    headerName: "Updated At",
    field: "updatedAt",
    sortable: true,
    cellRenderer: updatedAtRender,
    tooltipValueGetter: (params) =>
      convertIntoDashUSFormat(params.data.updatedAt, true),
  },
  {
    ...DefaultColumnOptions.Actions,
    cellRenderer: actionColumnRenderer(roles, onGoalsUpdated, onGoalsDeleted),
    hide: !isPermissionPresent(K.Permissions.SuperAdmin, roles),
  },
];
